module.exports = __webpack_public_path__ + "static/media/medal.29e416d7.svg";